import { b as _objectWithoutProperties, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { createContext } from 'react';
import { faUserTag, faHome, faTag, faFileContract, faUsers, faRupeeSign, faFileAlt, faFileUpload, faClipboardCheck, faChartBar, faUsersCog, faChartPie, faFileExcel, faBusinessTime } from '@fortawesome/free-solid-svg-icons';

var menu_config = {
  header: [{
    title: 'Client Service',
    icon: faUserTag,
    sidebar: [{
      title: 'Home',
      icon: faHome,
      link: '/home'
    }, {
      title: 'Quote',
      icon: faTag,
      submenu: [{
        subtitle: 'Get Quote',
        link: '/quote/select/product'
      }, {
        subtitle: 'Search Quotes',
        link: '/quote/saved'
      }, {
        subtitle: 'Smart Quotes Search',
        link: '/quote/saved/smart'
      }, {
        subtitle: 'Search Proposal',
        link: '/proposal/search'
      }]
    }, {
      title: 'Policy',
      icon: faFileContract,
      submenu: [{
        subtitle: 'Search Policy',
        link: '/policy/search'
      }, {
        subtitle: 'Renew Policy',
        link: '/policy/renew/search'
      }, {
        subtitle: 'Endorse Policy',
        link: '/policy/endorse/search'
      }]
    }, {
      title: 'Manage Customer',
      icon: faUsers,
      submenu: [{
        subtitle: 'Search Customer',
        link: '/customer/search'
      }, {
        subtitle: 'Create Customer',
        link: '/customer/create'
      }]
    }, {
      title: 'Payments',
      icon: faRupeeSign,
      submenu: [{
        subtitle: 'Search Payments',
        link: '/payments/search'
      }, {
        subtitle: 'Manage CD accounts',
        link: '/payments/managecdaccount'
      }, {
        subtitle: 'CD Transaction History',
        link: '/payments/cd-transaction-history'
      }, {
        subtitle: 'Generate PayIn-Slip',
        link: '/payments/generate-payslip'
      }, {
        subtitle: 'Download Deposition Slip',
        link: '/payments/download-deposition-slip'
      }]
    }, //if required uncommment title claims 
    {
      title: 'Claims',
      icon: faFileAlt,
      submenu: [{
        subtitle: 'Register & Track Health Claims',
        link: '/claims/Health/track'
      }, {
        subtitle: 'Register & Track Motor Claims',
        link: '/claims/Motor/track'
      }]
    }, {
      title: 'Financer Details',
      icon: faFileAlt,
      link: '/financerdetails'
    }, {
      title: 'Uploads',
      icon: faFileUpload,
      link: '/upload-documents'
    }, {
      title: 'Product Level UW Control',
      icon: faFileAlt,
      submenu: [{
        subtitle: 'Pincode Exclusion Master',
        link: '/productleveluw/pincode-exclusion'
      }, {
        subtitle: 'Default Master',
        link: '/productleveluw/default-master'
      }]
    }, {
      title: 'Vehicle Inspection',
      icon: faClipboardCheck,
      link: '/vehicle-inspection'
    }]
  }, {
    title: 'Reports',
    icon: faChartBar,
    sidebar: [{
      title: 'Home',
      icon: faHome,
      link: '/home'
    }, {
      title: 'Users',
      icon: faUsersCog,
      submenu: [{
        subtitle: 'Manage Roles',
        link: '/security/roles'
      }, {
        subtitle: 'Create External User',
        link: '/security/user/external/new'
      }, {
        subtitle: 'Create Internal User',
        link: '/security/user/internal/new'
      }, {
        subtitle: 'Manage Intermediary Users',
        link: '/security/users/search/intermediary'
      }, {
        subtitle: 'Search User',
        link: '/security/users/search'
      }]
    }, {
      title: 'Dashboard',
      icon: faChartPie,
      link: '/sales-dashboard'
    }, {
      title: 'Reports',
      icon: faFileExcel,
      link: '/reports/raise-and-track-report'
    }, {
      title: 'Business Limits',
      icon: faBusinessTime,
      submenu: [// {
      //   subtitle: 'Create Business Limits',
      //   link: '/create-business-limits'
      // },
      //  {
      //   subtitle: 'Manage Business Limits',
      //    link: '/business-limits'
      //  },
      // {
      //    subtitle: 'Manage Default Business Limits',
      //    link: '/managedefaultlimits'
      //  },
      {
        subtitle: 'Agent Level UW Limits',
        link: '/agent-level-UW-limits'
      }]
    }]
  }],
  footer: [{
    title: 'Privacy Policy',
    link: 'https://www.zurichkotak.com/privacy-policy'
  }, {
    title: 'Disclaimer',
    link: 'https://www.zurichkotak.com/disclaimer'
  } // {
  //   title: 'Privacy Policy',
  //   link: '/landing',
  // },
  // {
  //   title: 'Disclaimer',
  //   link: '/landing',
  // },
  // {
  //   title: 'Site Map',
  //   link: '/landing',
  // },
  // {
  //   title: 'Browser & Display Compatibility',
  //   link: '/landing',
  // },
  ]
};

var quote_products = [{
  product_code: '0000',
  icon: '/illustrations/products/general-01.png'
}, {
  product_code: '2877',
  icon: '/illustrations/products/health-01.png'
}, {
  product_code: '2880',
  icon: '/illustrations/products/health-02.png'
}, {
  product_code: '2883',
  icon: '/illustrations/products/health-03.png'
}, {
  product_code: '2885',
  icon: '/illustrations/products/health-04.png'
}, {
  product_code: '3191',
  icon: '/illustrations/products/TW_Secure.jpg'
}, {
  product_code: '3192',
  icon: '/illustrations/products/TW_LiabilityOnly.jpg'
}, {
  product_code: '3137',
  icon: '/illustrations/products/GCV.jpg'
}, {
  product_code: '3183',
  icon: '/illustrations/products/PCV.jpg'
}, {
  product_code: '3152',
  icon: '/illustrations/products/two-wheeler-03.png'
}, {
  product_code: '3151',
  icon: '/illustrations/products/two-wheeler-04.png'
}, {
  product_code: '3153',
  icon: '/illustrations/products/Accident-Cover.jpg'
}, {
  product_code: '3176',
  icon: '/illustrations/products/two-wheeler-04.png'
}, {
  product_code: '3121',
  icon: '/illustrations/products/car-01.png'
}, {
  product_code: '3128',
  icon: '/illustrations/products/MISCD.jpg'
}, {
  product_code: '4201',
  icon: '/illustrations/products/ipa-01.png'
}, {
  product_code: '1132',
  icon: '/illustrations/products/fire-01.png'
}, {
  product_code: '1133',
  icon: '/illustrations/products/fire-02.png'
}, {
  product_code: '1131',
  icon: '/illustrations/products/fire-03.png'
}, {
  product_code: '2117',
  icon: '/illustrations/products/marine-01.png'
}, {
  product_code: '4501',
  icon: '/illustrations/products/travel-01.png'
}, {
  product_code: '2904',
  icon: '/illustrations/products/misc-01.png'
}, {
  product_code: '2901',
  icon: '/illustrations/products/misc-02.png'
}];

var theme_list = ['alpha', 'aqua', 'mist', 'green', 'retro', 'pastel'];

var _excluded = ["children"];
var ConfigContext = /*#__PURE__*/createContext();
function ConfigProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: _objectSpread2({
      menu: menu_config,
      quote_products: quote_products,
      theme: theme_list
    }, props)
  }, children);
}

export { ConfigProvider as C, ConfigContext as a };
